import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-purchase-invoice',
  templateUrl: './purchase-invoice.component.html',
  imports: [CentToEurDisplayDirective, DatePipe]
})
export class PurchaseInvoiceTemplateComponent implements OnInit {

  public purchase: any = {}
  public provider: any = {}
  public purchaseLines: any[] = []
  public pay_method: any = null
  id: string | null = null
  type: string | null = null

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  @ViewChild('invoice')
  content!: ElementRef;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.type = this.route.snapshot.paramMap.get('type');
    this.getData(this.id);
  }

  getDocumentLabel(type: string): string {
    const labels: Record<string, string> = {
      'factura': 'Nº Factura',
      'albaran': 'Nº Albarán',
      'devolucion': 'Nº Devolución'
    };
    return labels[type] ?? '';
  }

  getData(id: any): any {
    this.apiService.getById(Urls.urls.purchases, id).subscribe({
      next: (data: any) => {
        this.purchase = data.purchase;
        this.provider = data.provider;
        this.purchaseLines = data.purchase_details;
        this.pay_method = data.pay_method;
        this.cdr.detectChanges();
        if (this.type === 'print') {
          window.print();
        }
      },
      error: (error: any) => {
        console.error('ERROR obtener compra. ' + error);
      },
    });
  }
}
